export default {

  setAgoraRadio (context , value) {
    context.commit('SET_AGORA_RADIO', value)
  },
  setSiteContent(context , value){
    context.commit('SET_SITE_CONTENT', value)
  },
  builderInfo (context , value) {
    context.commit('SETBUILDERINFO', value)
  },
  currentInfo (context , value) {
    context.commit('SETCURRENTINFO', value)
  },
  setRedeSocial (context , value) {
    context.commit('SET_REDE_SOCIAL', value)
  },
  setBlocos (context , value) {
    context.commit('SET_BLOCOS', value)
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js